const fields = require('../fields')
const parentFilter = require('./forgeProcessFilters.validator')

const forgeProcessAllFiltersSchema = parentFilter.keys({
    nickname: fields.nicknameField,
})

module.exports = forgeProcessAllFiltersSchema